// Clean public URL builders. Keep API URLs and backend endpoints untouched.
import { encodeId } from "../hash";

const cleanSegment = (value) =>
  String(value ?? "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

export const publicId = (value) => {
  const raw = String(value ?? "").trim();
  // API IDs are numeric; route params may already contain a Hashids value.
  // Encode numeric IDs once, but never encode an already-hashed route ID again.
  return /^\d+$/.test(raw) ? encodeId(Number(raw)) : raw;
};

const publicUrls = {
  auctions: () => "/auctions",
  auction: (slug, id) => `/auction/${cleanSegment(slug)}/${publicId(id)}`,
  lot: (slug, id, lotNo, title = "") => {
    const base = `/auction/${cleanSegment(slug)}/${publicId(id)}/lot/${encodeURIComponent(lotNo)}`;
    const titleSlug = cleanSegment(title);
    return titleSlug ? `${base}/${titleSlug}` : base;
  },
  privateSales: (data) =>
    data ? `/private-sales?data=${encodeURIComponent(data)}` : "/private-sales",
  privateSale: (group, id, title = "") => {
    const base = `/private-sales/${cleanSegment(group)}/${publicId(id)}`;
    const titleSlug = cleanSegment(title);
    return titleSlug ? `${base}/${titleSlug}` : base;
  },
  stories: () => "/stories",
  story: (slug) => `/stories/${cleanSegment(slug)}`,
  exhibition: (slug, id) => `/exhibitions/${cleanSegment(slug)}/${publicId(id)}`,
  exhibitions: () => "/exhibitions",
  location: (name) => `/locations/${cleanSegment(name)}`,
  account: () => "/account",
  favorites: () => "/account/favorites",
  lots: () => "/account/lots",
  signup: () => "/signup",
  forgotPassword: () => "/forgot-password",
  contact: () => "/contact",
  auctionRoom: () => "/auction-room",
};

export { publicUrls };
export default publicUrls;
